import { useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import { Link } from 'gatsby';
import { useAuth0 } from '@auth0/auth0-react';

import { getNavLinkProps, scrollToAnchor } from '@/utils';
import { mainRoutes } from '@/resources';

import { OffCanvasToggler } from '../OffCanvasToggler';
import { UserPanel } from '../UserPanel';

import { Wrapper } from './styled';

interface NavigationProps {
    offCanvasActive?: boolean;
    closeOffCanvas: () => void;
}

/**
 * Navigation Komponente
 */
export const Navigation = ({
    offCanvasActive = true,
    closeOffCanvas
}: NavigationProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    useOnClickOutside(wrapperRef, closeOffCanvas);

    const { isAuthenticated } = useAuth0();

    /**
     * Achtung: Styles für "navlink" sind unter "GlobalStyles" definiert
     */
    return (
        <Wrapper ref={wrapperRef} $offCanvasActive={offCanvasActive}>
            <OffCanvasToggler $showCloser onClick={closeOffCanvas} />
            {mainRoutes.map(({ to, text }) => {
                const key = `main-nav-${text}`;
                return to.charAt(0) === `#` ? (
                    <a
                        key={key}
                        className="navlink"
                        href={to}
                        onClick={evt => {
                            closeOffCanvas();
                            scrollToAnchor(evt);
                        }}
                    >
                        {text}
                    </a>
                ) : (
                    <Link
                        key={key}
                        className="navlink"
                        to={to}
                        getProps={getNavLinkProps}
                        onClick={closeOffCanvas}
                    >
                        {text}
                    </Link>
                );
            })}
            {isAuthenticated && <UserPanel />}
        </Wrapper>
    );
};
